import {
  ADD_TYPOLOGY_TO_MAPPING,
  ADD_TYPOLOGY_TO_MAPPING_FAIL,
  ADD_TYPOLOGY_TO_MAPPING_SUCCESS,
  CLEAR_UPLOAD_TYPOLOGIES,
  CONFIRM_TRM_TYPOLOGIES,
  CONFIRM_TRM_TYPOLOGIES_FAIL,
  CONFIRM_TRM_TYPOLOGIES_SUCCESS,
  CREATE_CHALLENGER,
  CREATE_CHALLENGER_FAIL,
  CREATE_CHALLENGER_SUCCESS,
  CREATE_SINGLE_SCENARIO,
  CREATE_SINGLE_SCENARIO_FAIL,
  CREATE_SINGLE_SCENARIO_SUCCESS,
  DELETE_SINGLE_SCENARIO,
  DELETE_SINGLE_SCENARIO_FAIL,
  DELETE_SINGLE_SCENARIO_SUCCESS,
  DISCARD_TRM_TYPOLOGIES,
  FETCH_ALL_SCENARIOS,
  FETCH_ALL_SCENARIOS_FAIL,
  FETCH_ALL_SCENARIOS_SUCCESS,
  FETCH_CURRENT_CHALLENGER,
  FETCH_CURRENT_CHALLENGER_FAIL,
  FETCH_CURRENT_CHALLENGER_SUCCESS,
  FETCH_CHALLENGERS_SUMMARY,
  FETCH_CHALLENGERS_SUMMARY_RESET,
  FETCH_CHALLENGERS_SUMMARY_FAIL,
  FETCH_CHALLENGERS_SUMMARY_SUCCESS,
  FETCH_CURRENT_CHAMPION,
  FETCH_CURRENT_CHAMPION_FAIL,
  FETCH_CURRENT_CHAMPION_SUCCESS,
  FETCH_RUN_INSTANCE_HISTORY,
  FETCH_RUN_INSTANCE_HISTORY_FAIL,
  FETCH_RUN_INSTANCE_HISTORY_SUCCESS,
  FETCH_SINGLE_SCENARIO,
  FETCH_SINGLE_SCENARIO_FAIL,
  FETCH_SINGLE_SCENARIO_SUCCESS,
  FETCH_SINGLE_SCENARIO_RESET,
  FETCH_TICKETS,
  FETCH_TICKETS_FAIL,
  FETCH_TICKETS_SUCCESS,
  FETCH_TRM_TYPOLOGIES,
  FETCH_TRM_TYPOLOGIES_FAIL,
  FETCH_TRM_TYPOLOGIES_OF_SCENARIO,
  FETCH_TRM_TYPOLOGIES_OF_SCENARIO_FAIL,
  FETCH_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS,
  FETCH_TRM_TYPOLOGIES_SUCCESS,
  REVERT_CURRENT_CHAMPION,
  REVERT_CURRENT_CHAMPION_FAIL,
  REVERT_CURRENT_CHAMPION_SUCCESS,
  TRIGGER_SCENARIO,
  TRIGGER_SCENARIO_FAIL,
  TRIGGER_SCENARIO_INIT,
  TRIGGER_SCENARIO_SUCCESS,
  UPDATE_SINGLE_SCENARIO,
  UPDATE_SINGLE_SCENARIO_FAIL,
  UPDATE_SINGLE_SCENARIO_SUCCESS,
  PROMOTE_CHALLENGER,
  PROMOTE_CHALLENGER_SUCCESS,
  PROMOTE_CHALLENGER_FAIL,
  FETCH_CURRENT_CHAMPION_RESET,
  CREATE_SINGLE_SCENARIO_RESET,
  FETCH_BLACKLIST_SUCCESS,

  // configure run instance
  SAVE_TYPOLOGY_SEGMENTS,
  SAVE_TYPOLOGY_SEGMENTS_FAIL,
  SAVE_TYPOLOGY_SEGMENTS_SUCCESS,
  FETCH_SCENARIO_TYPOLOGIES,
  FETCH_SCENARIO_TYPOLOGIES_FAIL,
  FETCH_SCENARIO_TYPOLOGIES_SUCCESS
} from '../../actions/trm/trmDashboard';
import { fromJS } from 'immutable';

const initialState = fromJS({
  trmTypologies: {
    isLoading: false,
    error: null,
    data: {
      totalCount: 0,
      typologies: []
    }
  },
  scenarioTypologiesList: {
    isLoading: false,
    error: null,
    data: {
      totalCount: 0,
      typologies: []
    }
  },
  runInstanceHistoryList: {
    isLoading: false,
    error: null,
    data: null
  },
  uploadConfirmed: '',
  discardConfirmed: '',
  challengerActions: {
    isLoading: false
  },
  createdScenario: {
    isLoading: false,
    error: null,
    data: {}
  },
  deletedScenario: {
    isLoading: false,
    error: null,
    data: {}
  },
  updatedScenario: {
    isLoading: false,
    error: null,
    data: {}
  },
  allScenarios: {
    isLoading: false,
    error: null,
    data: {}
  },
  challengersSummary: {
    isLoading: false,
    error: null,
    data: {}
  },
  singleScenario: {
    isLoading: false,
    error: null,
    data: {}
  },
  typologyScenarioMapping: {
    isLoading: false,
    error: null,
    data: {}
  },
  triggeredScenarioStatus: {
    isLoading: false,
    error: null,
    data: {}
  },
  ticketsList: {
    isLoading: false,
    error: null,
    data: null,
    totalCount: 0
  },
  currentChampion: {
    isLoading: false,
    error: null,
    data: null
  },
  currentChallenger: {
    isLoading: false,
    error: null,
    data: null
  },
  // look here for create run instance objects
  typologySegment: {
    isLoading: false,
    error: null,
    data: null,
    isSaved: false
  },
  scenarioTypologies: {
    isLoading: false,
    error: null,
    data: null
  }
  // create run instance END
});

export default function trmDashboard(state = initialState, action) {
  switch (action.type) {
    // look here for create run instance reducers
    case FETCH_SCENARIO_TYPOLOGIES:
      return {
        ...state,
        scenarioTypologies: {
          isLoading: true,
          data: {
            totalCount: 0,
            typologies: []
          },
          error: null
        }
      };
    case FETCH_SCENARIO_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        scenarioTypologies: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_SCENARIO_TYPOLOGIES_FAIL:
      return {
        ...state,
        scenarioTypologies: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case SAVE_TYPOLOGY_SEGMENTS:
      return {
        ...state,
        typologySegment: {
          isLoading: true,
          data: {
            totalCount: 0,
            typologies: []
          },
          error: null,
          isSaved: false
        }
      };
    case SAVE_TYPOLOGY_SEGMENTS_SUCCESS:
      return {
        ...state,
        typologySegment: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null,
          isSaved: true
        }
      };
    case SAVE_TYPOLOGY_SEGMENTS_FAIL:
      return {
        ...state,
        typologySegment: {
          isLoading: false,
          data: null,
          error: action.payload,
          isSaved: false
        }
      };
    // create run instance END
    case FETCH_TRM_TYPOLOGIES:
      return {
        ...state,
        trmTypologies: {
          isLoading: true,
          data: {
            totalCount: 0,
            typologies: []
          },
          error: null
        }
      };
    case FETCH_TRM_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        trmTypologies: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_TRM_TYPOLOGIES_FAIL:
      return {
        ...state,
        trmTypologies: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case CONFIRM_TRM_TYPOLOGIES:
      return {
        ...state,
        uploadConfirmed: {
          isLoading: true,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case CONFIRM_TRM_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        uploadConfirmed: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case CONFIRM_TRM_TYPOLOGIES_FAIL:
      return {
        ...state,
        uploadConfirmed: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case DISCARD_TRM_TYPOLOGIES:
      return {
        ...state,
        discardConfirmed: {
          isLoading: true,
          data: {
            ...action.payload
          },
          error: null
        }
      };

    case CLEAR_UPLOAD_TYPOLOGIES:
      return {
        ...initialState
      };

    case FETCH_ALL_SCENARIOS:
      return {
        ...state,
        allScenarios: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case FETCH_ALL_SCENARIOS_SUCCESS:
      return {
        ...state,
        allScenarios: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_ALL_SCENARIOS_FAIL:
      return {
        ...state,
        allScenarios: {
          isLoading: false,
          data: state.allScenarios.data,
          error: action.payload.error
        }
      };

    case FETCH_CHALLENGERS_SUMMARY:
      return {
        ...state,
        challengersSummary: {
          isLoading: true,
          data: null,
          error: null
        }
      };

    case FETCH_CHALLENGERS_SUMMARY_SUCCESS:
      return {
        ...state,
        challengersSummary: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };

    case FETCH_CHALLENGERS_SUMMARY_FAIL:
      return {
        ...state,
        challengersSummary: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_CHALLENGERS_SUMMARY_RESET:
      return {
        ...state,
        challengersSummary: {
          isLoading: false,
          data: {},
          error: null
        }
      };

    case CREATE_CHALLENGER:
    case PROMOTE_CHALLENGER:
    case REVERT_CURRENT_CHAMPION:
      return {
        ...state,
        challengerActions: {
          isLoading: true
        }
      };

    case CREATE_CHALLENGER_SUCCESS:
    case CREATE_CHALLENGER_FAIL:
    case PROMOTE_CHALLENGER_SUCCESS:
    case PROMOTE_CHALLENGER_FAIL:
    case REVERT_CURRENT_CHAMPION_SUCCESS:
    case REVERT_CURRENT_CHAMPION_FAIL:
      return {
        ...state,
        challengerActions: {
          isLoading: false
        }
      };

    case CREATE_SINGLE_SCENARIO:
      return {
        ...state,
        createdScenario: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case CREATE_SINGLE_SCENARIO_RESET:
      return {
        ...state,
        createdScenario: {
          isLoading: false,
          data: null,
          error: null
        }
      };
    case CREATE_SINGLE_SCENARIO_SUCCESS:
      return {
        ...state,
        createdScenario: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case CREATE_SINGLE_SCENARIO_FAIL:
      return {
        ...state,
        createdScenario: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_SINGLE_SCENARIO:
      return {
        ...state,
        singleScenario: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case FETCH_SINGLE_SCENARIO_SUCCESS:
    case FETCH_SINGLE_SCENARIO_RESET:
      return {
        ...state,
        singleScenario: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_SINGLE_SCENARIO_FAIL:
      return {
        ...state,
        singleScenario: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case DELETE_SINGLE_SCENARIO:
      return {
        ...state,
        deletedScenario: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case DELETE_SINGLE_SCENARIO_SUCCESS:
      return {
        ...state,
        deletedScenario: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case DELETE_SINGLE_SCENARIO_FAIL:
      return {
        ...state,
        deletedScenario: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case UPDATE_SINGLE_SCENARIO:
      return {
        ...state,
        updatedScenario: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case UPDATE_SINGLE_SCENARIO_SUCCESS:
      return {
        ...state,
        updatedScenario: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case UPDATE_SINGLE_SCENARIO_FAIL:
      return {
        ...state,
        updatedScenario: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case ADD_TYPOLOGY_TO_MAPPING:
      return {
        ...state,
        typologyScenarioMapping: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case ADD_TYPOLOGY_TO_MAPPING_SUCCESS:
      return {
        ...state,
        typologyScenarioMapping: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case ADD_TYPOLOGY_TO_MAPPING_FAIL:
      return {
        ...state,
        typologyScenarioMapping: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case TRIGGER_SCENARIO_INIT:
      return {
        ...state,
        triggeredScenarioStatus: {
          isLoading: false,
          data: null,
          error: null
        }
      };
    case TRIGGER_SCENARIO:
      return {
        ...state,
        triggeredScenarioStatus: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case TRIGGER_SCENARIO_SUCCESS:
      return {
        ...state,
        triggeredScenarioStatus: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case TRIGGER_SCENARIO_FAIL:
      return {
        ...state,
        triggeredScenarioStatus: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_TRM_TYPOLOGIES_OF_SCENARIO:
      return {
        ...state,
        scenarioTypologiesList: {
          isLoading: true,
          data: {
            totalCount: 0,
            typologies: []
          },
          error: null
        }
      };
    case FETCH_TRM_TYPOLOGIES_OF_SCENARIO_SUCCESS:
      return {
        ...state,
        scenarioTypologiesList: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_TRM_TYPOLOGIES_OF_SCENARIO_FAIL:
      return {
        ...state,
        scenarioTypologiesList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_RUN_INSTANCE_HISTORY:
      return {
        ...state,
        runInstanceHistoryList: {
          isLoading: true,
          data: null,
          error: null
        }
      };
    case FETCH_RUN_INSTANCE_HISTORY_SUCCESS:
      return {
        ...state,
        runInstanceHistoryList: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_RUN_INSTANCE_HISTORY_FAIL:
      return {
        ...state,
        runInstanceHistoryList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_TICKETS:
      return {
        ...state,
        ticketsList: {
          isLoading: true,
          data: null,
          error: null,
          totalCount: 0
        }
      };

    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        ticketsList: {
          isLoading: false,
          data: action.payload.requests,
          totalCount: action.payload.totalCount,
          error: null
        }
      };
    case FETCH_TICKETS_FAIL:
      return {
        ...state,
        ticketsList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_CURRENT_CHAMPION:
      return {
        ...state,
        currentChampion: {
          isLoading: true,
          data: null,
          error: null
        }
      };

    case FETCH_CURRENT_CHAMPION_SUCCESS:
      return {
        ...state,
        currentChampion: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };

    case FETCH_BLACKLIST_SUCCESS:
      return {
        ...state,
        blackList: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_CURRENT_CHAMPION_FAIL:
      return {
        ...state,
        currentChampion: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case FETCH_CURRENT_CHAMPION_RESET:
      return {
        ...state,
        currentChampion: {
          isLoading: false,
          data: null,
          error: null
        }
      };

    case FETCH_CURRENT_CHALLENGER:
      return {
        ...state,
        currentChallenger: {
          isLoading: true,
          data: null,
          error: null
        }
      };

    case FETCH_CURRENT_CHALLENGER_SUCCESS:
      return {
        ...state,
        currentChallenger: {
          isLoading: false,
          data: {
            ...action.payload
          },
          error: null
        }
      };
    case FETCH_CURRENT_CHALLENGER_FAIL:
      return {
        ...state,
        currentChallenger: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    default:
      return state;
  }
}
